<template>
  <div class="login">
    <h1>Login</h1>
    <small class="error" v-if="saved">wrong password</small>
    <input type="password" v-model="password" @keydown.enter="login"/>
    <div class="btn" @click="login">Login</div>
    <small>In case you do not have a login, please contact your <a href="https://www.betafilm.com/en/team.html" target="_blank">sales rep</a>.</small>
  </div>
</template>

<script lang="ts">
import { SHA256 } from "crypto-js";

import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      password: "",
      saved: localStorage.getItem('password'),
    };
  },
  methods:{
    login(){
      localStorage.setItem('password', SHA256(this.password).toString());
      location.reload();
    },
  }
});
</script>

<style scoped>
.login{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
input{
  background: transparent;
  border: none;
  border-bottom: 1px solid #fff;
  color: #fff;
  outline: none;
  font-size: 30px;
  width: 300px;
}
input:focus{
  border-bottom: 1px solid #f32735;
}
.error{
  color: #f32735;
}
a {
  color: #fff;
}
.btn{
  background-color: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: 1px solid #f32735;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 2vh;
  padding: 1.7vh;
  font-weight: 500;
  transition: transform 0.3s linear;
  cursor: pointer;
  margin: 2vh;
}
.btn:hover{
  transform: scale(1.1);
}
</style>
